import * as tslib_1 from "tslib";
import setBlockedSendersOption from '../actions/setBlockedSendersOption';
import store from '../store/store';
import { getMailboxJunkEmailConfiguration } from 'owa-junkmail-configuration';
import { getFallbackValueIfNull } from 'owa-options-core';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
import { EditSendersAndDomains, isEmailAddress, } from 'owa-mail-option-common';
import { OptionDescription } from 'owa-options-controls';
var BlockedSendersFull = /** @class */ (function (_super) {
    tslib_1.__extends(BlockedSendersFull, _super);
    function BlockedSendersFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChangeBlockedSenders = function (blockedSenders) {
            setBlockedSendersOption(blockedSenders);
        };
        return _this;
    }
    BlockedSendersFull.prototype.render = function () {
        var senders = getFallbackValueIfNull(this.props.optionState.blockedSenders, this.props.junkEmailConfiguration.BlockedSendersAndDomains.filter(function (item) {
            return isEmailAddress(item);
        }));
        return (React.createElement("div", null, senders && (React.createElement("div", null,
            React.createElement(OptionDescription, null, strings.options_junkEmail_blockedSenders),
            React.createElement(EditSendersAndDomains, { items: senders, onItemsChanged: this.onChangeBlockedSenders, mode: 0 /* EmailAddressOnly */ })))));
    };
    BlockedSendersFull = tslib_1.__decorate([
        reactive({
            optionState: function () { return store; },
            junkEmailConfiguration: function () { return getMailboxJunkEmailConfiguration(); },
        })
    ], BlockedSendersFull);
    return BlockedSendersFull;
}(React.Component));
export default BlockedSendersFull;
//# sourceMappingURL=BlockedSendersFull.js.map